export default __webpack_public_path__ + "static/media/ShunsukeMurasaki.96e534a0.png";